<template>
  <div class="relative object-cover flex" :class="wrapperClasses">
    <img
      v-if="imgSrc"
      :src="imgSrc"
      :class="['!h-full w-full', classes, (props.forceCover || isLandscape) ? 'object-cover' : 'object-contain']"
      alt="thumbnail"
      @load="onLoad"
      @error="onError" />
    <div v-show="loading" ref="placeholderRef" class="absolute inset-0 h-full w-full flex items-center justify-center">
      <q-spinner size="60px" color="primary" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onUnmounted, ref } from 'vue';
import type { Ref } from 'vue';
import { useIntersectionObserver } from '@/composables/useIntersectionObserver';
import { getAssetsS3Path, S3PathType } from '@/helpers/assets';

interface Props {
  path: string;
  type: S3PathType;
  wrapperClasses?: string[];
  classes?: string[];
  forceCover?: boolean;
}

const props = defineProps<Props>();

const imgSrc = ref('');
const isLandscape = ref(false);
const loading = ref(true);
const placeholderRef: Ref<HTMLDivElement | null> = ref(null);
const controller = new AbortController();

const onLoad = () => {
  loading.value = false;
};
const onError = () => {
  loading.value = false;
};
const loadAsset = async () => {
  try {
    const src = await getAssetsS3Path(props.path, props.type, controller);

    if (!src) {
      imgSrc.value = '';
      return;
    }
    imgSrc.value = src;
    const img = new Image();
    img.src = src;

    img.onload = () => {
      if (img.width > img.height) {
        isLandscape.value = true;
      } else {
        isLandscape.value = false;
      }
    };
  } catch (e) {
    console.warn('Failed to load asset', e);
  }
};

useIntersectionObserver(placeholderRef, loadAsset);

onUnmounted(() => {
  controller.abort();
});
</script>
